import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText } from "vue"

const _hoisted_1 = {
  class: "bg-white",
  style: {"margin":"10px!important"}
}
const _hoisted_2 = { class: "col-xs-12 col-sm-12 col-md-12 col-lg-12" }
const _hoisted_3 = {
  class: "card-header",
  style: {"background-color":"transparent"}
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "col-1 d-flex" }, [
  /*#__PURE__*/_createElementVNode("b", { class: "mt-4" }, "Reportes ")
], -1)
const _hoisted_7 = { class: "col-8 d-flex align-self-baseline align-items-baseline" }
const _hoisted_8 = { class: "container p-0" }
const _hoisted_9 = { class: "row p-0 d-flex justify-content-center" }
const _hoisted_10 = { class: "col-2 pt-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("label", { for: "" }, null, -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("option", {
  value: "0",
  selected: "",
  disabled: ""
}, "Estatus", -1)
const _hoisted_13 = ["value"]
const _hoisted_14 = { class: "col-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "" }, null, -1)
const _hoisted_16 = {
  class: "",
  name: "",
  id: "sltProblema"
}
const _hoisted_17 = ["value"]
const _hoisted_18 = { class: "col-2 pt-4" }
const _hoisted_19 = { class: "col-2 pt-4" }
const _hoisted_20 = { class: "col-1" }
const _hoisted_21 = { class: "col-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _withDirectives(_createElementVNode("select", {
                      class: "form-control col-6",
                      id: "buscarStatus",
                      name: "status",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objSearch.status) = $event))
                    }, [
                      _hoisted_12,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusArray, (option) => {
                        return (_openBlock(), _createElementBlock("option", {
                          key: option,
                          value: option
                        }, _toDisplayString(option), 9, _hoisted_13))
                      }), 128))
                    ], 512), [
                      [_vModelSelect, _ctx.objSearch.status]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objSearch.phone_number) = $event)),
                      class: "form-control",
                      list: "sltProblema"
                    }, null, 512), [
                      [_vModelText, _ctx.objSearch.phone_number]
                    ]),
                    _createElementVNode("datalist", _hoisted_16, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.devicesArray, (dev) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: dev.phone_number,
                          key: dev.phone_number
                        }, _toDisplayString(dev.phone_number), 9, _hoisted_17))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objSearch.finicio) = $event)),
                      type: "text",
                      class: "form-control",
                      id: "txtfinicio",
                      name: "txtfinicio",
                      placeholder: "f.inicio",
                      onfocus: "(this.type='date')"
                    }, null, 512), [
                      [_vModelText, _ctx.objSearch.finicio]
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objSearch.ffin) = $event)),
                      type: "text",
                      class: "form-control",
                      id: "txtffinal",
                      name: "txtffinal",
                      placeholder: "f.final",
                      onfocus: "(this.type='date')"
                    }, null, 512), [
                      [_vModelText, _ctx.objSearch.ffin]
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("button", {
                class: "btn btn-sm border border-success form-control mt-4",
                onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.btnExport && _ctx.btnExport(...args)))
              }, " excel ")
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("button", {
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.btnSearch && _ctx.btnSearch(...args))),
                class: "btn btn-sm border border-danger form-control mt-4"
              }, " Buscar ")
            ])
          ])
        ])
      ])
    ])
  ]))
}